'use es6';

import Log from 'forms-utils-lib/logger/Logger';
import { fetchSubscriptionDefinitionsByBusinessUnitId } from 'FormsCommonComponents/api/LegalConsent';
import { requestSubscriptionDefinitions, retrivedSubscriptionDefinitions, failSubscriptionDefinitions } from 'FormsCommonComponents/actions/LegalConsent';
import { hasBusinessUnitsAccess as getHasBusinessUnitsAccess } from 'FormsUI/selectors/BusinessUnitsAccess';
import { isUngatedForCampaignBusinessUnit as getIsUngatedForCampaignBusinessUnit } from 'FormsUI/selectors/Gates';
import { getSelectedBusinessUnitId } from 'FormsUI/selectors/FormCreation';
import { getBusinessUnitIdForLegalConsent } from 'FormsCommonComponents/utils/BusinessUnitsUtils';
export const getSubscriptionDefinitionsByBusinessUnitId = () => (dispatch, getState) => {
  const state = getState();
  const selectedBusinessUnitId = getSelectedBusinessUnitId(state);
  const isUngatedForCampaignBusinessUnit = getIsUngatedForCampaignBusinessUnit(state);
  const hasBusinessUnitsAccess = getHasBusinessUnitsAccess(state);
  const businessUnitId = getBusinessUnitIdForLegalConsent({
    businessUnitId: selectedBusinessUnitId,
    isUngatedForCampaignBusinessUnit,
    hasBusinessUnitsAccess
  });
  dispatch(requestSubscriptionDefinitions({
    businessUnitId
  }));
  return fetchSubscriptionDefinitionsByBusinessUnitId({
    businessUnitId,
    hasBusinessUnitsAccess,
    isUngatedForCampaignBusinessUnit
  }).then(definitions => {
    dispatch(retrivedSubscriptionDefinitions({
      subscriptionDefinitions: definitions
    }));
  }, ({
    xhr
  }) => {
    dispatch(failSubscriptionDefinitions());
    Log.logServiceError('Failed to fetch Legal Consent', xhr);
  });
};
export default getSubscriptionDefinitionsByBusinessUnitId;